/**
 * Simple frontend logger utility that adds consistency to console logging
 * and could be extended to send logs to a backend service if needed
 */
export const logger = {
  info: (message, data) => {
    if (data) {
      console.info(`[INFO] ${message}`, data);
    } else {
      console.info(`[INFO] ${message}`);
    }
  },
  
  warn: (message, data) => {
    if (data) {
      console.warn(`[WARN] ${message}`, data);
    } else {
      console.warn(`[WARN] ${message}`);
    }
  },
  
  error: (message, data) => {
    if (data) {
      console.error(`[ERROR] ${message}`, data);
    } else {
      console.error(`[ERROR] ${message}`);
    }
  },
  
  debug: (message, data) => {
    // Only log in development
    if (process.env.NODE_ENV !== 'production') {
      if (data) {
        console.debug(`[DEBUG] ${message}`, data);
      } else {
        console.debug(`[DEBUG] ${message}`);
      }
    }
  }
};

export default logger; 